import {useFilterManagement} from '../../../store/hooks/useFilterManagement'
import {useStatesAndHealthConditions} from '../../../store/hooks/breadCrumbs'
import {getState} from '../../../shared/helpers/getState'
import {usePersona} from '../../../store/hooks/persona'

export function useGetFiltersData() {
  const {getQueryParams, getOutreachParams} = useFilterManagement()
  const {filters} = useStatesAndHealthConditions()
  const {personaSidebarOpen, personas} = usePersona()

  const appliedFilterParams = getQueryParams()
  const currentStateFromContext = filters && getState(filters)

  // Get outreach params (benefits only for now)
  const outreach = getOutreachParams()
  const benefitsData = outreach.type === 'benefits' ? outreach.data : []

  const filtersData = {
    ...appliedFilterParams,
    state: currentStateFromContext,
    persona: personas
  }

  return {filtersData, personaSidebarOpen, benefitsData}
}
